<template>
  <div class="container__content">
    <div class="wrapper">
      <!-- 上層开奖資訊區塊 -->
      <div class="content-7">
        <lottery-item :lottery-code="activeCode" />
      </div>
      <!-- 彩種選擇器 -->
      <!-- 中間 header, 還缺 datePicker -->
      <div class="content-8">
        <div class="content-8__titlebar">
          <div class="content-8__titlebar__left">
            <div class="c8-titlename">
              <span class="c8-titlename__text">购彩计划：(已推荐{{ recommendPeriods }}期)</span>
            </div>
          </div>
          <div class="content-8__titlebar__right">
            <div class="fn-wrap">
              <a class="button-outline c8-datebox__item" @click.prevent="openDescription">
                <span class="button-outline__text">帮助说明</span>
              </a>
            </div>
            <lottery-date-filter-tab @updateForm="chooseDate" />
          </div>
        </div>
        <Loading v-if="isLoading" />
        <template v-else>
          <template v-if="tableList.length > 0">
            <!-- 中下 計畫tabbar-->
            <div class="content-8__controlbar">
              <div class="content-8__controlbar__item">
                <div class="c8-select">
                  <div class="c8-select__content">
                    <a
                      v-for="nav in planNavList"
                      :key="nav.label"
                      :class="{'active': activePlan === nav.key}"
                      class="button-outline c8-select__content__item"
                      @click="changePlan(nav)"
                    >
                      <span class="button-outline__text">{{ nav.label }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- table -->
            <div class="content-8__content">
              <table v-if="tableList" class="even-color">
                <thead>
                  <tr>
                    <th>期数</th>
                    <th>开奖结果</th>
                    <th>{{ setTableHead }}</th>
                    <th>当前成本</th>
                    <th>累计成本</th>
                    <th>赢利/亏损</th>
                    <th>开奖时间</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in tableList" :key="row.period">
                    <td>{{ row.period }}</td>
                    <td>
                      <!-- 最新一期开奖字串 -->
                      <span
                        v-if="row.balls.length === 1"
                        :class="row.balls[0].class"
                      >{{ row.balls[0].val }}</span>
                      <lottery-balls
                        v-else
                        :lottery-code="activeCode"
                        :lottery-type="lotteryType"
                        :datas-type="'balls'"
                        :datas="row.balls"
                      />
                    </td>
                    <td>
                      <lottery-balls
                        :lottery-code="activeCode"
                        :lottery-type="lotteryType"
                        :datas-type="'prediction'"
                        :datas="row.predictions"
                      />
                    </td>
                    <td>{{ row.jihuaCost }}</td>
                    <td>{{ row.totalJihuaCost }}</td>
                    <td :class="row.jihuaProfit.class">{{ row.jihuaProfit.val }}</td>
                    <td>{{ row.drawTime }}</td>
                  </tr>
                </tbody>
              </table>
              <ClickMoreBtn v-if="moreBtnExists" :btn-hide="noMoreData" @show-more="showMoreInfo" />
            </div>
          </template>
          <NoData v-else />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getBuyPlans_web } from '@/api/desktop/basic-Sean'
import * as moment from 'moment-mini'

import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
import lotteryItem from '@/components/web/pages/trend/LotteryItem'
import lotteryBalls from '@/components/web/pages/buyplan/LotteryBalls'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import ClickMoreBtn from '@/components/web/pages/trend/ClickMoreBtn'
import chunk from 'lodash.chunk'

export default {
  name: 'WebBuyPlan',
  components: {
    // LotterySelector,
    LotteryDateFilterTab,
    lotteryItem,
    lotteryBalls,
    Loading,
    NoData,
    ClickMoreBtn
  },
  async asyncData({ app, params }) {
    const { lottery_code } = params
    const lotteryType = await app.$getLotteryType(lottery_code)

    return { lotteryType }
  },
  data() {
    return {
      tableList: [],
      recommendPeriods: 0,
      planNavList: [
        { label: '计划一', key: 'jihuaBalls5r1' },
        { label: '计划二', key: 'jihuaBalls4r1' },
        { label: '计划三', key: 'jihuaBalls3r1' }
      ],
      activeCode: this.$route.params.lottery_code,
      lotteryType: null,
      activePlan: 'jihuaBalls5r1',
      activeField: 'hm1',
      activeDate: {
        count: '30',
        date: undefined
      },
      isLoading: false,
      chunkInfo: {
        lists: [],
        index: 0,
        last: 0,
        isLast: false
      }
    }
  },
  computed: {
    setTableHead() {
      let prefix
      switch (this.lotteryType) {
        case 'pk10':
          prefix = '冠军购彩'
          break
        case 'ssc':
        case '11x5':
          prefix = '第一球购彩'
          break
        case 'k3':
        case 'xy28':
          prefix = '和值购彩'
          break
      }
      const postfix = this.planNavList.find(ele => ele.key === this.activePlan).label
      return `${prefix} ${postfix}`
    },
    noMoreData() {
      return this.chunkInfo.isLast
    },
    moreBtnExists() {
      return !this.isLoading && this.tableList.length > 0
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const lotteryType = this.lotteryType
      switch (lotteryType) {
        case 'pk10':
        case 'ssc':
        case '11x5':
          this.planNavList = [
            { label: '计划一', key: 'jihuaBalls5r1' },
            { label: '计划二', key: 'jihuaBalls4r1' },
            { label: '计划三', key: 'jihuaBalls3r1' }
          ]
          this.activePlan = 'jihuaBalls5r1'
          this.activeField = 'hm1'
          break
        case 'k3':
        case 'xy28':
          this.planNavList = [
            { label: '计划一', key: 'jihuaZongHe5r1' },
            { label: '计划二', key: 'jihuaZongHe4r1' },
            { label: '计划三', key: 'jihuaZongHe3r1' }
          ]
          this.activePlan = 'jihuaZongHe5r1'
          this.activeField = 'all'
          break
      }
    },
    async getBuyPlans(dateData) {
      const query = {
        cpCode: this.activeCode,
        planCode: this.activePlan,
        field: this.activeField,
        ...dateData
      }
      this.resetChunkInfo()
      this.isLoading = true
      const [data, error] = await getBuyPlans_web(query)
      if (error) return

      const predictionsList = data.predictions.map((pred) => {
        const period = `${pred.period.slice(-8)}期`
        const win = pred.win
        const result = pred.result
        let jihuaProfit, balls
        if (win === 0) {
          balls = [{ val: '等待开奖', class: 'red', isCorrect: false }]
          jihuaProfit = { val: '?', class: 'red' }
        } else {
          balls = pred.balls.map((ball, ballIndex) => ({
            val: ball,
            isCorrect:
              ballIndex === 0 && ball.toString() === result && pred.predictions.includes(result)
          }))
          jihuaProfit = {
            val: pred.jihuaProfit,
            class: pred.jihuaProfit > 0 ? 'red' : 'blue'
          }
        }
        const predictions = pred.predictions.map((ball) => ({
          val: ball,
          isCorrect: ball === result
        }))
        const jihuaCost = pred.jihuaCost
        const totalJihuaCost = pred.totalJihuaCost
        const drawTime = moment(pred.drawTime).format('HH:mm:ss')
        return {
          period,
          balls,
          predictions,
          result,
          win,
          jihuaCost,
          totalJihuaCost,
          jihuaProfit,
          drawTime
        }
      })
      // 加上分頁
      // 對資料切片，以 "顯示更多" 按鈕來決定資料呈現
      Object.assign(this.chunkInfo, this.chunkData(predictionsList))
      this.tableList = this.chunkInfo.lists[this.chunkInfo.index] || []

      this.recommendPeriods = data.todayPredictedCount
      this.isLoading = false
    },
    changePlan(listItem) {
      this.activePlan = listItem.key
      this.getBuyPlans(this.activeDate)
    },
    chooseDate(form) {
      Object.assign(this.activeDate, form)
      this.getBuyPlans(this.activeDate)
    },
    openDescription() {
      this.$store.commit('lottery/OPEN_DESCRIPTION', { name: '帮助说明', lotteryCode: '', descriptionType: 'prediction' })
    },
    resetChunkInfo() {
      Object.assign(this.chunkInfo, { lists: [], index: 0, last: 0, isLast: false })
    },
    chunkData(data) {
      const lists = chunk(data, 31)
      const index = 0
      const last = lists.length - 1
      const isLast = index >= last
      return { lists, index, last, isLast }
    },
    showMoreInfo() {
      const { last, lists } = this.chunkInfo
      this.chunkInfo.index++
      if (this.chunkInfo.index === last) {
        this.chunkInfo.isLast = true
      }
      this.tableList = this.tableList.concat(lists[this.chunkInfo.index])
    }
  }
}
</script>

<style scoped>
.fn-wrap {
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: 16px;
  margin-right: 16px;
  border-right:solid 1px #EBEBEB
}
</style>

